import React from 'react';
import styles from './ProfessorDashboard.module.css';

function DashboardHeader({ viewMode, onViewModeChange, students, totalPages, totalStudents, currentPage, pageSize }) {
  return (
    <div className={styles.header}>
      <div className={styles.headerTop}>
        <h1 className={styles.dashboardTitle}>Professor Dashboard</h1>
        <div className={styles.viewToggle}>
          <button
            onClick={() => onViewModeChange('card')}
            className={`${styles.viewButton} ${
              viewMode === 'card' ? styles.viewButtonActive : styles.viewButtonInactive
            }`}
          >
            Card View
          </button>
          <button
            onClick={() => onViewModeChange('bar')}
            className={`${styles.viewButton} ${
              viewMode === 'bar' ? styles.viewButtonActive : styles.viewButtonInactive
            }`}
          >
            List View
          </button>
        </div>
      </div>
      <div className={styles.resultsSummary}>
        {students.length > 0 && (
          <p>
            Showing {students.length} of {totalStudents} students
            (Page {currentPage} of {totalPages})
          </p>
        )}
      </div>
    </div>
  );
}

export default DashboardHeader;